(function () {

    // var addmultiintes  = $(".btn-add-item");
    // $.each(addmultiintes, function(){
    //     $(this).click(function(){
    //         alert("sasad");
    //     });
    // });


    $(document).on('click', '.btn-add-item', function () {

        const id = $(this).attr("index");
        let clone = null;
        if (id != null) {
            clone = $(".item-line[index=" + id + "]").last().clone();
        } else {
            clone = cloneline($(".item-line"));
        }

        const inputs = clone.find('input, select,img,label');

        $.each(inputs, function () {
            const SPMaskBehavior = function (val) {
                    return val.replace(/\D/g, '').length === 11 ? '(99) 99999-9999' : '(99) 9999-99999';
                },
                spOptions = {
                    onKeyPress: function (val, e, field, options) {
                        field.inputmask(SPMaskBehavior.apply({}, arguments), options);
                    }
                };
            const input = $(this);
            //limpa campos de imput
            input.val('');
            //incrementa indice
            if (input.attr('for') != null) {
                var name = increaseIndex($(this).attr('for'));
                $(this).attr('for', name);
            } else {
                var name = increaseIndex(input.attr('name'));
                input.attr('name', name);
                const id = increaseIndex(input.attr('id'));
                input.attr('id', id);
                input.attr("value", "");

            }

            if (input.attr("type") == "file") {
                input.on("change", function () {
                    const fileName = $(this).val().split("\\").pop();
                    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
                });
                input.next().html("Selecione um arquivo");
            }
            if (input.attr("src") != null) {
                input.attr("src", null)
            }
        });
        if (id != null) {
            $(".item-body[index=" + id + "]").prepend(clone);
        } else {
            $(".item-body").prepend(clone);
        }

        removeItem();

    });


    function removeItem() {
        //adiciona evento remover e valida para nao retirar todos
        const uls = $(".item-body");
        uls.each(function () {


            const itens = $(this).find("li");
            itens.each(function () {

                const item = $(this);
                const btnremove = item.find("button");
                btnremove.unbind('click');
                btnremove.bind("click", function () {

                    const id = $(this).attr("index");
                    console.log(id);
                    if (id != null) {

                        if ($(".item-line[index=" + id + "]").length == 1) {
                            $(".btn-add-item[index=" + id + "]").trigger("click");
                        }
                    } else {
                        if ($(".item-line").length == 1) {
                            $(".btn-add-item").trigger("click");
                        }
                    }

                    item.remove();

                });
            });
        });

    }
    removeItem();
})();


function increaseIndex(name) {
    if (name !== undefined) {
        let index = parseInt(name.match(/\[(\d+)\](?!.*\[\d+\])/)[1]);
        index = index + 1;
        name = name.replace(/\[(\d+)\](?!.*\[\d+\])/, '[' + index + ']');
    }
    return name;
}
function cloneline(list) {
    let more = 0;
    let item = null;
    if ($(this).hasClass("item_index")) {
        $.each(list, function () {
            //debugger;
            const input = $(this).find(".item_index");


            const index = parseInt(input.attr("name").match(/\[(\d+)\](?!.*\[\d+\])/)[1]);

            if (item == null) {
                more = index;
                item = $(this).clone();
            }

            if (index > more) {
                more = index;
                item = $(this).clone();
            }


        });
    } else {
        item = list.first().clone();
    }
    return item;
}
